/*
 * IcInventurQueries.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-12-31 in huWaWi3 33.20.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import gql from 'graphql-tag'

import { INVENTURBESTAETIGUNG_FRAGMENT } from '../fragments'

export const UNGEZAEHLT_QUERY = gql`
  query IntventurUnbestaetigung($cursor: String, $inventurName: String) {
    nodes: hwIcIntventurBestaetigungPages(
      after: $cursor
      filter: { gezaehlt: { eq: false }, inventur: { eq: $inventurName } }
      sort: { fields: [lager, artnr], order: ASC }
      limit: 10000
    ) {
      edges {
        cursor
        node {
          artnr
          lager
          zaehlbestand
          gezaehlt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`
export const EINEBESTAETIGUNG_QUERY = gql`
  query EineIntventurBestaetigung($cursor: String, $lager: String, $sku: String, $inventurName: String) {
    nodes: hwIcIntventurBestaetigungPages(
      after: $cursor
      filter: { lager: { eq: $lager }, artnr: { eq: $sku }, inventur: { eq: $inventurName } }
      limit: 10000
    ) {
      edges {
        cursor
        node {
          ...intventurBestaetigungFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${INVENTURBESTAETIGUNG_FRAGMENT}
`
export const GEZAEHLT_QUERY = gql`
  query InventurGezaehlt($cursor: String, $inventurName: String) {
    nodes: hwIcIntventurBestaetigungPages(
      after: $cursor
      filter: { gezaehlt: { eq: true }, inventur: { eq: $inventurName } }
      sort: { fields: [lager, artnr], order: ASC }
      limit: 10000
    ) {
      edges {
        cursor
        node {
          artnr
          lager
          zaehlbestand
          gezaehlt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`
